import { render } from "./SoftAlert.vue?vue&type=template&id=06d28ae6&scoped=true"
import script from "./SoftAlert.vue?vue&type=script&lang=js"
export * from "./SoftAlert.vue?vue&type=script&lang=js"

import "./SoftAlert.vue?vue&type=style&index=0&id=06d28ae6&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d28ae6"]])

export default __exports__